export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCvUTje5l_2hOU-osgpMKWFVbqjNLFoxk4',
  authDomain: 'silken-dogfish-126421.firebaseapp.com',
  databaseURL: 'https://silken-dogfish-126421.firebaseio.com',
  projectId: 'silken-dogfish-126421',
  storageBucket: '',
  messagingSenderId: '709431371156',
};

export const URL = {
  HOME: '/',
  VOCABULARY: '/vocabulary',
  PHRASES: '/phrases',
  GRAMMAR: '/grammar',
  USERS: '/users',
  SETTINGS: '/settings',
  LESSONS: '/lessons',
  TOPICS: '/topics',
  NOTIFICATIONS: '/notifications',
  STATISTICS: '/statistics',
  MESSAGES: '/messages',
  SUPERADMIN: '/superadmin',
};

export const LANG = {
  ORIGINAL: 'cz',
  OTHER: 'en',
};

export const SUPERADMIN = ['ales@berger.cz', 'michal@macinka.cz'];

export const VERSION = '1.1.0';



// WEBPACK FOOTER //
// ./src/config.js